export const PaperBloomIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.333 8.5h-5M6 11.833H4.333M11 5.167H4.333m10 2.916V5c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 00-1.093-1.093C12.434 1 11.733 1 10.333 1H5c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093C1 2.9 1 3.6 1 5v6.667c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092c.535.273 1.235.273 2.635.273h2.25m8.75 0l-1.25-1.25m.833-2.084a2.917 2.917 0 11-5.833 0 2.917 2.917 0 015.833 0z"
    />
  </svg>
);
